import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {Router} from '@angular/router';
import {appVersion} from '@atmi/core';

import {LogoutAction, User, UserTypeActions} from '@atmi/core/models';
import {UserService} from '@atmi/core/services/user.service';

import {filter, first, map} from 'rxjs/operators';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent {

  @Output() readonly clickMenu = new EventEmitter();

  readonly username$ = this.userService.selectQueryState<User>('user').pipe(
    filter((user): user is User => !!user),
    map((user) => user.username)
  );

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    @Inject(appVersion) public readonly version: string,
  ) {
    this.userService.selectQueryState('action')
      .pipe(
        first((action) => action === UserTypeActions.LOGOUT),
      ).subscribe(() => {
      console.log('LOGIN');
      this.router.navigate(['/login']);
    });
  }

  toggleMenuHandler() {
    this.clickMenu.emit();
  }

  logoutHandler() {
    this.userService.dispatch(new LogoutAction());
  }

  settingsHandler() {
    this.router.navigate(['/profile']);
  }
}
